// DS8.1M
import React from 'react';
import c from 'classnames';
import s from './ModalFooterMobile.scss';

export interface Props {
  className?: string;
  primaryButton: React.ReactNode;
  secondaryButton?: React.ReactNode;
  bottomExtras?: React.ReactNode;
}

const ModalFooterMobile: React.FC<Props> = ({
  className,
  primaryButton,
  secondaryButton,
  bottomExtras,
}) => {
  return (
    <div className={c(className, s['root'])}>
      <div className={s['buttons-wrapper']}>
        {secondaryButton}
        {primaryButton}
      </div>
      {bottomExtras && <div className={s['bottom-extras']}>{bottomExtras}</div>}
    </div>
  );
};
ModalFooterMobile.displayName = 'ModalFooterMobile';

export default ModalFooterMobile;
